import { CircularProgress, Divider } from "@material-ui/core";
import * as React from "react";
import { useSelector } from "react-redux";
import { ELearningListData } from "../../../../models/elearning";
import { TrainingType } from "../../../../models/enums/trainingType.enum";
import { Pagination } from "../../../../models/pagination";
import { AppState } from "../../../../redux";
import NoEventsFound from "../shared/NoEventsFound";
import { EventItem } from "./eventItem/EventItem";
import { useTranslation } from "react-i18next";

interface PageItemsProps {
  pages: Pagination<ELearningListData>[];
}

const PageItems: React.FC<PageItemsProps> = (props) => {
  const { t } = useTranslation(["events"]);

  const noTopicsDefault = t("eventFilter.sortingFilters.noTopicsDefault", {
    ns: "events",
  });

  const eventState = useSelector((state: AppState) => state.event);
  const eventFilterData = eventState.filterData;
  const sortingFilter = useSelector((state: AppState) => state.event.sortingFilter);
  const { pages } = props;
  const flattenEvents = (events: Pagination<ELearningListData>[]) => {
    return events.flatMap((page) => page.results);
  };
  const events = flattenEvents(pages);
  // TODO: remove this after elearnings are established
  const showNoElearningsYetText = eventFilterData.training_type.includes(
    TrainingType.ELearning
  );
  const loading = pages.length === 0 || events.length === 0;
  const groupEventsByName = (items: any[]) => {
    const grouped: { [letter: string]: any[] } = {};
    items.forEach((event: any) => {
      const title = event.title || "";
      const firstLetter = title[0]?.toUpperCase() || "#";

      if (!grouped[firstLetter]) {
        grouped[firstLetter] = [];
      }

      grouped[firstLetter].push(event);
    });
    return grouped;
  };

  const groupEventsByTopic = (items: any[]) => {
    const grouped: { [topic: string]: any[] } = {};

    items.forEach((event: any) => {
      const topic = event.topic ? event.topic.name : noTopicsDefault;
      if (!grouped[topic]) {
        grouped[topic] = [];
      }
      grouped[topic].push(event);
    });
    return grouped;
  };

  const renderEvents = (event: any) => {
    return (
      <React.Fragment key={`event-${event.id}`}>
        <EventItem event={event} />
        <Divider className="event-list-separator" />
      </React.Fragment>
    );
  };
  const groupedEventsName = groupEventsByName(events);
  const groupedEventsTopic = groupEventsByTopic(events);

  if (loading) return <CircularProgress />;

  return (
    <div>
      {events.length === 0 ? (
        <NoEventsFound
          key="no-events"
          customText={
            showNoElearningsYetText
              ? "Es stehen in Kürze E-Learnings zur Verfügung."
              : undefined
          }
        />
      ) : sortingFilter === "name" ? (
        Object.keys(groupedEventsName)
          .sort()
          .map((letter) => (
            <div key={letter}>
              <h1>{letter}</h1>
              <Divider
                style={{ border: "0.1rem solid" }}
                className="event-list-separator"
              />
              {groupedEventsName[letter].map((event: any) => renderEvents(event))}
            </div>
          ))
      ) : sortingFilter === "topic" ? (
        Object.keys(groupedEventsTopic).map((topic) => (
          <div key={topic}>
            <h1>{topic}</h1>
            <Divider
              style={{ border: "0.1rem solid" }}
              className="event-list-separator"
            />
            {groupedEventsTopic[topic].map((event: any) => renderEvents(event))}
          </div>
        ))
      ) : (
        events.map((event) => renderEvents(event))
      )}
    </div>
  );
};

export default PageItems;
